declare global {
  interface Window {
    uetq?: any[];
    UET?: new (options: { ti: string; enableAutoSpaTracking?: boolean; q?: any[] }) => { push: (...args: any[]) => void };
    __uetInitialized?: boolean;
  }
}

const UET_TAG_ID = '187237928';
const UET_SCRIPT_ID = 'bing-uet-loader';

export const initUet = (): void => {
  if (typeof window === 'undefined' || window.__uetInitialized) {
    return;
  }

  window.uetq = window.uetq || [];

  const bootstrap = () => {
    const UETConstructor = window.UET;
    if (typeof UETConstructor !== 'function') {
      return;
    }

    const queue = window.uetq || [];
    const uet = new UETConstructor({
      ti: UET_TAG_ID,
      enableAutoSpaTracking: true,
      q: queue,
    });

    window.uetq = uet as unknown as any[];
    (window.uetq as any).push('pageLoad');
    window.__uetInitialized = true;
  };

  const existingScript = document.getElementById(UET_SCRIPT_ID) as HTMLScriptElement | null;
  if (existingScript) {
    bootstrap();
    return;
  }

  const script = document.createElement('script');
  script.id = UET_SCRIPT_ID;
  script.src = 'https://bat.bing.com/bat.js';
  script.async = true;
  script.onload = bootstrap;
  script.onreadystatechange = function () {
    const state = this.readyState;
    if (!state || state === 'loaded' || state === 'complete') {
      bootstrap();
      script.onload = null;
      script.onreadystatechange = null;
    }
  };

  const firstScript = document.getElementsByTagName('script')[0];
  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
  } else {
    document.head.appendChild(script);
  }
};

export const setUetDefaultConsentDenied = (): void => {
  if (typeof window === 'undefined') return;
  window.uetq = window.uetq || [];
  window.uetq.push('consent', 'default', {
    ad_storage: 'denied',
  });
};

export const updateUetConsent = (granted: boolean): void => {
  if (typeof window === 'undefined') return;
  window.uetq = window.uetq || [];
  window.uetq.push('consent', 'update', {
    ad_storage: granted ? 'granted' : 'denied',
  });
};
